import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProfileServiceService {

  constructor(@Inject('baseUrl') private baseUrl:string,
  private http:HttpClient) { }

  getBaseUrl():string{
    return this.baseUrl;
  }

  
}
